import React from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import '../../pages/LandingPage.css';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  // Google Ads conversion event trigger
  const triggerConversion = () => {
    if (typeof window !== 'undefined' && typeof (window as any).gtag === 'function') {
      (window as any).gtag('event', 'conversion', {
        'send_to': 'AW-17359198207/1DZzCKzav_EaEP-vwdVA'
      });
    }
  };

  return (
    <footer style={{
      background: isDark 
        ? 'rgba(255, 255, 255, 0.02)' 
        : 'rgba(255, 255, 255, 0.8)',
      backdropFilter: 'blur(20px)',
      borderTop: isDark 
        ? '1px solid rgba(255, 255, 255, 0.1)' 
        : '1px solid rgba(31, 41, 55, 0.1)',
      color: isDark 
        ? 'rgba(255, 255, 255, 0.8)' 
        : 'rgba(31, 41, 55, 0.8)',
      padding: '20px',
      textAlign: 'center',
      fontFamily: "'Space Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      position: 'relative',
      zIndex: 1,
    }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        gap: 12,
        marginBottom: '8px',
        flexWrap: 'wrap'
      }}>
        <img 
          src={isDark ? "/tenantterms_white_compact.png" : "/tenantterms_black_compact.png"}
          alt="TenantTerms logo" 
          style={{ 
            maxHeight: 30, 
            marginRight: 4,
            filter: isDark 
              ? 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))'
              : 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))'
          }} 
        />
        <p style={{ 
          margin: 0,
          fontSize: '1rem',
          color: isDark 
            ? 'rgba(255, 255, 255, 0.9)' 
            : 'rgba(31, 41, 55, 0.9)',
          fontWeight: 500
        }}>
          {t('footer.poweredBy')}{' '}
          <span style={{ 
            color: '#EC4899',
            animation: 'pulse 2s ease-in-out infinite'
          }}>
            ❤️
          </span>
          {' '}{t('footer.forLandlords')}
        </p>
      </div>
      <p style={{ 
        fontSize: '13px',
        color: isDark 
          ? 'rgba(255, 255, 255, 0.65)' 
          : 'rgba(31, 41, 55, 0.65)',
        margin: '6px 0 4px'
      }}>
        <a 
          href="/terms" 
          style={{ 
            color: isDark ? '#A5B4FC' : '#4F46E5',
            fontWeight: 600,
            textDecoration: 'none',
            marginRight: 12
          }}
        >
          Terms & Legal Notice
        </a>
      </p>
      {/* Remove this button after testing, or trigger conversion on a real action */}
      <button onClick={triggerConversion} style={{ display: 'none' }}>Test Conversion Event</button>

      <style>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }
      `}</style>
    </footer>
  );
};

export default Footer; 
